import React from "react";
import ForgotPassword from "../../Components/forget-password";
export default function Forgot() {
  return (
    <>
      <ForgotPassword />
    </>
  );
}
